// import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:257px;
margin-top:100px;
margin-bottom:100px;

`;

export const ContainerFluidX = styled.div`
// border:2px dashed red;
width:100%;
min-height:468px;
margin-top:-250px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657178422/Frame_1_qt5z1q.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:bottom right;
`;



export const Container = styled.div
.attrs(() => ({
  className: 'container-custom mt-100',
}))`
min-height:668px;
background: rgba(0, 165, 104, 0.95);
box-shadow: 0px 20px 40px rgba(0, 165, 104, 0.3);
border-radius: 40px;

`;
export const ContainerX = styled.div
.attrs(() => ({
  className: 'container-custom ',
}))`
min-height:200px;

`;


export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
width: 386px;
min-height: 129px;
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 42px;
line-height: 103%;
/* or 43px */
color: #FFFFFF;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;
export const ParagraphText = styled.p
.attrs(() => ({
  className: '',
}))`
min-height: 174px;
font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 400;
font-size: 22px;
line-height: 132.5%;
color: #FFFFFF;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;

export const DescText = styled.p
.attrs(() => ({
  className: '',
}))`
min-height: 56px;
font-family: 'Cabinet Grotesk';
font-style: normal;
font-weight: 300;
font-size: 21px;
line-height: 135.5%;
/* or 28px */


color: #4A4A4A;
`;